import { FC, useRef } from 'react';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box } from '@mui/material';

import { onOpenEditorFromCopy } from 'store/global/globalSlice';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { useAppDispatch } from 'app/hooks';
import { ContextMenuType } from './types';
import { copy } from 'helpers/functions';
import { useTranslation } from 'react-i18next';
import { logEventFirebase } from 'utils/config/firebase';

const ContextMenu: FC<ContextMenuType> = ({ x, y, value, onClose, onRewrite }) => {
    const contextMenuRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    useOnClickOutside(contextMenuRef, onClose);

    const onCopy = () => {
        copy({ isSelection: true });
        onClose();
    };

    const onCopyComposingPad = () => {
        logEventFirebase('click_copy_to_composing_pad');
        copy({ isSelection: true });
        dispatch(onOpenEditorFromCopy(value));
        onClose();
    };

    return (
        <Box
            className="context-menu"
            ref={contextMenuRef}
            style={{ position: 'absolute', top: `${y}px`, left: `${x}px` }}
        >
            <Box>
                <button onClick={onCopy}>
                    {t('web_app.context_menu.copy')} <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                </button>
            </Box>
            <Box>
                <button onClick={onCopyComposingPad}>
                    {t('web_app.context_menu.copy_to_composing_pad')}{' '}
                    <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                </button>
            </Box>
            <Box>
                <button onClick={onRewrite}>
                    {t('web_app.context_menu.rewrite_selected_text')}{' '}
                    <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                </button>
            </Box>
        </Box>
    );
};
export default ContextMenu;
